import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../features/theme/ThemeContext';

/**
 * @param {'compact' | 'admin' | 'settings'} variant
 */
const ThemeToggle = ({ variant = 'compact', className = '' }) => {
  const { theme, setTheme, toggleTheme, isDark } = useTheme();

  if (variant === 'settings') {
    return (
      <div className={`jet-theme-picker ${className}`.trim()} role="group" aria-label="Appearance">
        <button
          type="button"
          className={`jet-theme-picker__btn${theme === 'light' ? ' is-active' : ''}`}
          onClick={() => setTheme('light')}
          aria-pressed={theme === 'light'}
        >
          <Sun size={16} aria-hidden />
          Light
        </button>
        <button
          type="button"
          className={`jet-theme-picker__btn${theme === 'dark' ? ' is-active' : ''}`}
          onClick={() => setTheme('dark')}
          aria-pressed={theme === 'dark'}
        >
          <Moon size={16} aria-hidden />
          Dark
        </button>
      </div>
    );
  }

  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      className={`jet-theme-toggle${variant === 'admin' ? ' jet-theme-toggle--admin' : ''} ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? <Sun size={18} strokeWidth={2} aria-hidden /> : <Moon size={18} strokeWidth={2} aria-hidden />}
    </button>
  );
};

export default ThemeToggle;
